module.exports = __webpack_public_path__ + "img/Group121.03147b71.png";